import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lawfirmId: null,
  locationId: null,
  lawfirmUserId: null,
  isLegalService: false, // ✅ added field
};

const lawfirmSlice = createSlice({
  name: "lawfirm",
  initialState,
  reducers: {
    setLawfirmId: (state, action) => {
      state.lawfirmId = action.payload;
    },
    setLocationId: (state, action) => {
      state.locationId = action.payload;
    },
    setLawfirmUserId: (state, action) => {
      state.lawfirmUserId = action.payload;
    },
    setIsLegalService: (state, action) => {
      state.isLegalService = action.payload;
    },
    resetLawfirm: () => initialState,
  },
});

export const {
  setLawfirmId,
  setLocationId,
  setLawfirmUserId,
  setIsLegalService,
  resetLawfirm,
} = lawfirmSlice.actions;

export default lawfirmSlice.reducer;
